const schema = {
  title: {
    type: 'text',
    label: 'Practice Title',
    placeholder: 'Enter title',
    required: true,
    info: true,
    character_count: 250,
    disabled: true
  },
  image: {
    type: 'file',
    label: 'Image',
    placeholder: 'Select Image',
    required: true,
    info: true,
  },
  website_url: {
    type: 'text',
    label: 'Website URL',
    placeholder: '',
    required: true,
    info: true,
  }
};

const pcnCategories = ['EMIS'];

const practices = [
  {
    id: "practice7092022",      
    active: true,
    imageUrl: "",
    title: "The Pheonix Practice",
    websiteUrl: ""
  },
  {
    id: "practice7092023",      
    active: true,
    imageUrl: "",
    title: "Dr Azim and Partners",
    websiteUrl: ""
  },
  {
    id: "practice7092024",      
    active: true,
    imageUrl: "",
    title: "Pennine Drive Medical Centre",
    websiteUrl: ""
  },
  {
    id: "practice7092025",      
    active: true,
    imageUrl: "",
    title: "Hill View Surgery",
    websiteUrl: ""
  },
  {
    id: "practice7092026",      
    active: true,
    imageUrl: "",
    title: "St Georges Medical Centre",
    websiteUrl: ""
  },
  {
    id: "practice7092027",      
    active: true,
    imageUrl: "",
    title: "Ravenscroft Medical Centre",
    websiteUrl: ""
  },
  {
    id: "practice7092028",      
    active: true,
    imageUrl: "",
    title: "Green Fields Medical Centre",
    websiteUrl: ""
  },
  {
    id: "practice7092029",      
    active: true,
    imageUrl: "",
    title: "Cricklewood Health Centre",
    websiteUrl: ""
  }
]

export { schema, practices, pcnCategories };